// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_access_requests_defaults.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Duration } from "../../../../google/protobuf/duration";
import { Empty } from "../../../../google/protobuf/empty";
/**
 * @generated from protobuf message c1.api.app.v1.AppAccessRequestDefaultsRef
 */
export interface AppAccessRequestDefaultsRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAccessRequestDefaults
 */
export interface AppAccessRequestDefaults {
    /**
     * The app id for the app access request rule
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The policy id for the emergency grant policy.
     *
     * @generated from protobuf field: string emergency_grant_policy_id = 2;
     */
    emergencyGrantPolicyId: string;
    /**
     * If emergency grants are enabled for this app access request rule.
     *
     * @generated from protobuf field: bool emergency_grant_enabled = 3;
     */
    emergencyGrantEnabled: boolean;
    /**
     * @generated from protobuf oneof: max_grant_duration
     */
    maxGrantDuration: {
        oneofKind: "durationUnset";
        /**
         * If this app access request rule does not have a max duration, this field is set with {}.
         *
         * @generated from protobuf field: google.protobuf.Empty duration_unset = 10;
         */
        durationUnset: Empty;
    } | {
        oneofKind: "durationGrant";
        /**
         * If this app access request rule has a max duration, this field is set with the max duration in seconds.
         *
         * @generated from protobuf field: google.protobuf.Duration duration_grant = 11;
         */
        durationGrant: Duration;
    } | {
        oneofKind: undefined;
    };
    /**
     * The request catalog ids for the app access request rule.
     *
     * @generated from protobuf field: repeated string catalog_ids = 4;
     */
    catalogIds: string[];
    /**
     * If true the app level request configuration will be applied to specified resource types.
     *
     * @generated from protobuf field: bool defaults_enabled = 5;
     */
    defaultsEnabled: boolean;
    /**
     * The last applied state of the app access request defaults.
     *
     * @generated from protobuf field: c1.api.app.v1.AppAccessRequestDefaultsLastApplyState state = 6;
     */
    state: AppAccessRequestDefaultsLastApplyState;
    /**
     * The app resource type ids for which the app access request defaults are applied.
     *
     * @generated from protobuf field: repeated string resource_type_ids = 7;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: string request_policy_id = 8;
     */
    requestPolicyId: string;
    /**
     * The ID of the request schema to apply to entitlements matching this rule.
     *
     * @generated from protobuf field: string request_schema_id = 9;
     */
    requestSchemaId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAccessRequestDefaultsRequest
 */
export interface GetAccessRequestDefaultsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CancelAccessRequestDefaultsRequest
 */
export interface CancelAccessRequestDefaultsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppAccessRequestDefaultsLastApplyState
 */
export enum AppAccessRequestDefaultsLastApplyState {
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_SUCCESS = 2;
     */
    SUCCESS = 2,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_FAILED = 3;
     */
    FAILED = 3,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_CANCELING = 4;
     */
    CANCELING = 4,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_CANCEL_SUCCESS = 5;
     */
    CANCEL_SUCCESS = 5,
    /**
     * @generated from protobuf enum value: APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_CANCEL_ERROR = 6;
     */
    CANCEL_ERROR = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class AppAccessRequestDefaultsRef$Type extends MessageType<AppAccessRequestDefaultsRef> {
    constructor() {
        super("c1.api.app.v1.AppAccessRequestDefaultsRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAccessRequestDefaultsRef
 */
export const AppAccessRequestDefaultsRef = new AppAccessRequestDefaultsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAccessRequestDefaults$Type extends MessageType<AppAccessRequestDefaults> {
    constructor() {
        super("c1.api.app.v1.AppAccessRequestDefaults", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "emergency_grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "emergency_grant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "duration_unset", kind: "message", oneof: "maxGrantDuration", T: () => Empty },
            { no: 11, name: "duration_grant", kind: "message", oneof: "maxGrantDuration", T: () => Duration },
            { no: 4, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "defaults_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "state", kind: "enum", T: () => ["c1.api.app.v1.AppAccessRequestDefaultsLastApplyState", AppAccessRequestDefaultsLastApplyState, "APP_ACCESS_REQUEST_DEFAULTS_LAST_APPLY_STATE_"] },
            { no: 7, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "request_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 9, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAccessRequestDefaults
 */
export const AppAccessRequestDefaults = new AppAccessRequestDefaults$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessRequestDefaultsRequest$Type extends MessageType<GetAccessRequestDefaultsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAccessRequestDefaultsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAccessRequestDefaultsRequest
 */
export const GetAccessRequestDefaultsRequest = new GetAccessRequestDefaultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelAccessRequestDefaultsRequest$Type extends MessageType<CancelAccessRequestDefaultsRequest> {
    constructor() {
        super("c1.api.app.v1.CancelAccessRequestDefaultsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CancelAccessRequestDefaultsRequest
 */
export const CancelAccessRequestDefaultsRequest = new CancelAccessRequestDefaultsRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppAccessRequestsDefaultsService
 */
export const AppAccessRequestsDefaultsService = new ServiceType("c1.api.app.v1.AppAccessRequestsDefaultsService", [
    { name: "CreateAppAccessRequestsDefaults", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/access_request_defaults", group: "AppAccessRequestDefaults" }] } }, I: AppAccessRequestDefaults, O: AppAccessRequestDefaults },
    { name: "GetAppAccessRequestsDefaults", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/access_request_defaults", group: "AppAccessRequestDefaults" }] } }, I: GetAccessRequestDefaultsRequest, O: AppAccessRequestDefaults },
    { name: "CancelAppAccessRequestsDefaults", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/access_request_defaults/cancel", group: "AppAccessRequestDefaults" }] } }, I: CancelAccessRequestDefaultsRequest, O: AppAccessRequestDefaults }
]);
